// extracted by css-extract-rspack-plugin
export default {"separator":"nifsI","column":"LUeEd","dropdown":"Y2Jak","placeholder":"rX0HC"};